var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactDribbble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "contact_dribbble",
    d: "M27.5,0A27.5,27.5,0,1,0,55,27.5,27.508,27.508,0,0,0,27.5,0ZM45.664,12.676a23.381,23.381,0,0,1,5.309,14.615,55.466,55.466,0,0,0-16.345-.746c-.179-.388-.328-.805-.507-1.223-.477-1.133-1.014-2.3-1.551-3.4C41.22,18.4,45.157,13.332,45.664,12.676ZM27.5,4.056A23.437,23.437,0,0,1,43.069,9.962c-.418.6-3.967,5.339-12.318,8.471a126.8,126.8,0,0,0-8.769-13.75A23.887,23.887,0,0,1,27.5,4.056ZM17.508,6.264a148.234,148.234,0,0,1,8.709,13.571A88.086,88.086,0,0,1,4.5,22.7,23.6,23.6,0,0,1,17.508,6.264ZM4,27.53v-.716a85.829,85.829,0,0,0,24.13-3.341c.686,1.312,1.312,2.654,1.909,4-.3.09-.626.179-.925.268C17,31.646,10.559,42.324,10.022,43.218A23.434,23.434,0,0,1,4,27.53ZM27.5,51a23.325,23.325,0,0,1-14.406-4.951c.418-.865,5.19-10.051,18.433-14.675.06-.03.09-.03.149-.06a97.1,97.1,0,0,1,5.011,17.806A23.1,23.1,0,0,1,27.5,51Zm13.094-4.027A101.056,101.056,0,0,0,36.03,30.244a34.3,34.3,0,0,1,14.615,1.014A23.287,23.287,0,0,1,40.594,46.977Z",
    fill: "#5637fa",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactDribbble);
export default __webpack_public_path__ + "static/media/contact_dribbble.5d126f5fbb3f67c402f9b96b955b0e67.svg";
export { ForwardRef as ReactComponent };